import { Observable } from 'rxjs';

export abstract class NapaFormTracker {
  abstract set index(value: number);
  abstract get index(): number;

  abstract index$: Observable<number>;

  abstract set completed(value: boolean);
  abstract get completed(): boolean;

  abstract completed$: Observable<boolean>;

  abstract set disabled(value: boolean);
  abstract get disabled(): boolean;

  abstract disabled$: Observable<boolean>;
}
